import React from "react";
import FormattedDate from "./FormattedDate";
import WeatherIcons from"./WeatherIcons";

import "./WeatherToday.css";

export default function WeatherToday(props) {
  return (
    <div className="WeatherToday">
      
        <div className="row">
          <div className="col-6">
            <h1 className="city">{props.data.city}</h1>
          </div>
          <div className="col">
            <div className="today">
              <div className="col-6">
                <div className="card">
                  <div className="card-body">
                    <h6 className="date-today">
                    <FormattedDate date={props.data.date}/>
                    </h6>
                    <h4 className="temp-today">
                      {Math.round(props.data.temperature)}°C
                    </h4>
                    <hr />
                    <div>
                      <WeatherIcons code={props.data.icon} />
                      </div>
                  
                    <h6>
                      <span className="description">
                        {props.data.description}
                      </span>
                    </h6>
                    <hr />
                    <h6 className="speed">
                      Wind speed :{Math.round(props.data.wind)} km/h
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    
  );
}
